<template>
  <div class="controls-wrapper">
    <icon-button icon="dollar-sign" :fa="true"  @click="showDialog = true"/>
    <el-dialog :append-to-body="true" v-if="showDialog" append-to-body width="400px" title="Add new price" :visible.sync="showDialog">
      <upsert-price-form
        v-if="showDialog"
        :stationId="station.id"
        :stations="organization.stations"
        @created="stationSpecificPriceCreated"
        :users="organizationUsers" />
    </el-dialog>

  </div>
</template>

<script>
import UpsertPriceForm from './../Pricing/UpsertForm'

export default {
  name: 'StationsControls',
  components: { UpsertPriceForm },
  props: {
    station: {
      type: Object,
      required: true
    },
    organization: {
      type: Object,
      required: true
    }
  },
  computed: {
    organizationUsers () {
      return this.organization.users.map(user => {
        return user.user
      })
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    stationSpecificPriceCreated (price) {
      this.$emit('priceCreated', price)
      this.showDialog = false
    }
  }
}
</script>

<style>
  .controls-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Stations/StationsControls.vue